import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations('app', ['SET_title', 'SET_expandedSearch']),
  },
};
